module.exports = __webpack_public_path__ + "static/media/icon-hospital.274fcbcb.svg";